import apiBlogNode from "../assets/img/blog-screen.png";
import socialMediaTW from "../assets/img/social-media-screen.png";
import musicApp from "../assets/img/music-app-screen.png";

export const projectsListBack = [
  {
    title: "API Blog",
    description: "NodeJS, Express, MongoDB, MVC",
    imgUrl: apiBlogNode,
    gitHubUrl: "https://github.com/Martin-J-Larre/api-blog-node",
    demoUrl: "https://api-blog-node.onrender.com/",
  },
  {
    title: "API Social Media",
    description: "NodeJS, Express, MongoDB, MVC",
    imgUrl: socialMediaTW,
    gitHubUrl: "https://github.com/Martin-J-Larre/api-social-media-node",
    demoUrl: "https://api-social-media-node.onrender.com/",
  },
  {
    title: "API Music App",
    description: "NodeJS, Express, MongoDB, MVC",
    imgUrl: musicApp,
    gitHubUrl: "https://github.com/Martin-J-Larre/music-app-node",
    demoUrl: "https://music-app-node.onrender.com",
  },
];
